import React from "react";
import { encStorage } from "../hooks/encStorage";
import axios from "axios";
const Logout = () => {
  encStorage.removeItem("token");
  encStorage.removeItem("name");
  encStorage.removeItem("client_code");
  encStorage.removeItem("id");
  encStorage.removeItem("client_id");
  window.location = "/login";
};

export default Logout;
